import React from "react";

// 🔹 Import dynamique sécurisé
// On utilise try/catch pour éviter une erreur si une image n’existe pas
const importImage = (path) => {
  try {
    return require(`../assets/${path}`);
  } catch {
    return "https://via.placeholder.com/400x300?text=Image+à+venir";
  }
};

export default function Realisations() {
  const images = [
     "travaux.jpeg",
    "travaux 2.jpeg",
    "travaux 3.jpeg",
    "travaux 4.jpeg",
    "travaux 5.jpeg",
    "travaux 6.jpeg",
    "travaux 7.jpeg",
    "travaux 8.jpeg",
    "travaux 9.jpeg",
  ];

  return (
    <section className="realisations" id="realisations">
      <div className="container">
        <h2>Nos Réalisations</h2>
        <p className="subtitle">
          Découvrez quelques exemples de nos travaux récents.
        </p>

        <div className="gallery">
          {images.map((file, index) => (
            <div className="gallery-item" key={index}>
              <img
                src={importImage(file)}
                alt={`Réalisation ${index + 1}`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}


